import { cloneDeep, isFunction, camelCase, kebabCase, snakeCase } from 'lodash'

import { inEnum, isObject } from '..'
import { Cases } from '../constants'

class Clonable {
  /** @returns {this} */
  clone (clone = {}) {
    return new this.constructor({ ...cloneDeep(this), ...cloneDeep(clone) })
  }

  /** @return {object} */
  toCase (caseFormat = Cases.CAMEL) {
    let formatted = { ...this }

    caseFormat = caseFormat?.toUpperCase()
    if (inEnum(Cases, caseFormat)) {
      if (caseFormat === Cases.CAMEL) {
        formatted = toCase(formatted, camelCase)
      } else if (caseFormat === Cases.SNAKE) {
        formatted = toCase(formatted, snakeCase)
      } else if (caseFormat === Cases.KEBAB) {
        formatted = toCase(formatted, kebabCase)
      }
    }

    return formatted
  }
}

export const toCase = (object, caseFormatter) => {
  if (!isFunction(caseFormatter)) {
    throw new Error('caseFormatter must be a function')
  }

  const clone = {}

  Object.entries(object).forEach(([key, value]) => {
    if (!isFunction(value)) {
      clone[caseFormatter(key)] = isObject(value) ? toCase(value, caseFormatter) : value
    }
  })

  return clone
}

export default Clonable
